export default {
    NONE: 'none',
    LOCAL: 'local',
    MONITORED: 'monitored',
};
